export default __webpack_public_path__ + "static/about-692a620b5459235b601d527aec5cdac4.mp4";